import React, { useState } from 'react';

const SERVICES = [
  'Pressure Washing',
  'Window Cleaning',
  'Gutter Cleaning',
  'Roof Cleaning',
  'Driveway Cleaning',
  'Sidewalk Cleaning',
  'Patio Cleaning',
  'Deck Cleaning',
  'Fence Cleaning',
  'Solar Panel Cleaning',
  'Pool Deck Cleaning',
  'Concrete Cleaning',
  'Graffiti Removal',
];

function MiniContactForm() {
  const [selectedServices, setSelectedServices] = useState([]);

  const handleCheckboxChange = (service) => {
    setSelectedServices((prev) =>
      prev.includes(service)
        ? prev.filter((s) => s !== service)
        : [...prev, service]
    );
  };

  return (
    <form className="bg-white p-6 rounded-lg shadow-md space-y-4">
      <h2 className="text-2xl font-bold text-[#4a3f35] mb-2">Quick Contact</h2>
      <div>
        <label className="block text-[#4a3f35] font-semibold mb-1">Name</label>
        <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#b87c4c]" placeholder="Your Name" required />
      </div>
      <div>
        <label className="block text-[#4a3f35] font-semibold mb-1">Email</label>
        <input type="email" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#b87c4c]" placeholder="you@email.com" required />
      </div>
      <div>
        <label className="block text-[#4a3f35] font-semibold mb-1">Phone (optional)</label>
        <input type="tel" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#b87c4c]" placeholder="(555) 555-5555" />
      </div>
      <div>
        <label className="block text-[#4a3f35] font-semibold mb-1">Service(s) Interested In</label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
          {SERVICES.map((service) => (
            <label key={service} className="flex items-center">
              <input
                type="checkbox"
                value={service}
                checked={selectedServices.includes(service)}
                onChange={() => handleCheckboxChange(service)}
                className="mr-2 accent-[#b87c4c]"
                required={selectedServices.length === 0}
              />
              {service}
            </label>
          ))}
        </div>
        {selectedServices.length === 0 && (
          <p className="text-xs text-red-500 mt-1">Please select at least one service.</p>
        )}
      </div>
      <div>
        <label className="block text-[#4a3f35] font-semibold mb-1">Message</label>
        <textarea className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#b87c4c]" rows="3" placeholder="How can we help you?" required></textarea>
      </div>
      <button type="submit" className="w-full bg-[#8B4513] text-white font-semibold py-2 rounded-lg shadow hover:bg-[#6B3410] transition-colors duration-200">Send</button>
    </form>
  );
}

export default MiniContactForm; 